import { CheckoutSessionDTO } from "utils/helpers/models/host-dtos/checkout-session.dto";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "../../utils/helpers/common/http-methods";
import { EVENT_STATUS } from "utils/helpers/enums/shared.enum";
import { BadgeDTO } from "utils/helpers/models/host-dtos/badge.dto";
import { MessageDTO } from "utils/helpers/models/shared/message.dto";
import { PostJoineeDTO } from "utils/helpers/models/host-dtos/postReviewJoinee.dto";
import { CreateEventPayloadDTO } from "utils/helpers/models/shared/event.dto";

export const Host_APIS = {
  uploadFile: (params: any) => postRequest("/file/upload", params),
  getProfileData: () => getRequest("/user/profile"),
  postUserData: (body: any) => postRequest("/host/update/profile", body),
  getCoreConcept: (body:any) => getRequest("/core-concepts", body),
  postBusinessProfileData: (body: any) =>postRequest("/host/update/business", body),
  getHostProfileData: () => getRequest("/user/profile"),
  getHostHome: () => getRequest("/host/home"),
  getAllEvents: (page: number, size: number) =>getRequest(`/event/get?page=${page}&size=${size}&sortBy=createdAt&sortDir=desc`),
  getEvents: (params: any) => getRequest(`/event/get`, params),
  getEventsTestingRefactored: (params: any) => getRequest(`/event/get/testing/refactored`, params),
  getHostEventDataById: (eventId: number) =>getRequest(`/event/${eventId}/details`),
  getEventById: (eventId: number) => getRequest(`/event/${eventId}/details`),
  registerRsvp: (body: any) => postRequest("/host/register-rsvp", body),
  // getRsvpData: () => getRequest("/host/rsvps"),
  getRsvps: () => getRequest("/host/rsvps"),
  updateRsvpById: (id: number, body: any) =>patchRequest(`host/rsvp/${id}/profile`, body),
  deleteRsvp: (rsvpId: number) => deleteRequest(`/host/delete-rsvp/${rsvpId}`),
  createEvent: (body: CreateEventPayloadDTO, state: EVENT_STATUS) =>postRequest(`/event/create?state=${state}`, body),
  getEventCommunities: (page = 0, size = 10) =>getRequest(`/event/communities?page=${page}&size=${size}`),
  getCommunities: (params: any) => getRequest(`/event/communities`, params),
  getCommunityMessages: (params: any) => getRequest(`/event/${params.eventId}/messages`, params),
  getCommunitiesMessagesById: (id: any, page = 0, size = 10) =>getRequest(`/event/${id}/messages?page=${page}&size=${size}&sortBy=createdAt&sortDir=desc`),
  sendMessageToCommunity: (body: MessageDTO) => postRequest(`/event/${body.eventId}/chat`, body),
  getSubscriptionPlans: () => getRequest(`stripe/products`),
  createCheckoutSession: (body: CheckoutSessionDTO) => postRequest(`stripe/create-checkout-session`, body),
  createBadge: (body: BadgeDTO) => postRequest(`badge`, body),
  getBadges: (params: any) => getRequest('badge', params),
  getAdminBadges: (params: any) => getRequest('badge/admin', params),
  getAwardedBadges: (params: any) => getRequest('/users/my/awarded/badges', params),
  cancelEvent: (eventId: number, body: any) => postRequest(`/event/${eventId}/cancel`, body),
  duplicateEvent: (eventId: number) => postRequest(`/event/${eventId}/duplicate`, {}),
  getLibraryResources: (params: any) => getRequest(`/resource-library`, params),
  getLibraryResourceById: (resourceId: number) => getRequest(`/resource-library/${resourceId}`),
  getReviewsByEventId: (eventId: number) => getRequest(`/cup-of-gratitue/reviews/${eventId}`),
  getCupsByEventId: (eventId: number) => getRequest(`/cup-of-gratitue/event/${eventId}`),
  markAttendance: (eventId: number , attendeeId: number , childId: number , workshopSessionId: number) => postRequest(`/event/${eventId}/attend/${attendeeId}/${childId}/${workshopSessionId}`,{}),
  getEventAttendance: (eventId: number) => getRequest(`/event/${eventId}/attendance/new`),
  postReviewJoinee: (eventId: number,body:PostJoineeDTO) => postRequest(`/event/${eventId}/review-event-joinee`,body),
  getHostBalance: () => getRequest(`/host-earnings/balance`),
  getHostEarnings: (params: any) => getRequest(`/host-earnings/earnings`, params),
  postStripeConnect: () => postRequest(`/host-earnings/stripe-connect`, {}),
  getStripeAccountStatus: () => getRequest(`/host-earnings/connection-status`),
  getHostRatedEvents: ( ) => getRequest(`/host/my-rated-events`),
  getHostEarningsOnboarding: () => getRequest(`/host-earnings/onboarding-link`),
  stripDashboardLink: () => getRequest(`/host-earnings/dashboard-link`),


  getCancelEventsTicketsListing: (params: any) => getRequest("/event/cancellation-tickets/my", params),
  postChatTicketMessages: (ticketId: number, body: any) => postRequest(`/event/cancellation-tickets/${ticketId}/chat`, body),
  getChatTicketMessages: (ticketId: number, params?: any) => getRequest(`/event/cancellation-tickets/${ticketId}/chat`, params),
  hostCancelSubscribtion : (params?:any) => deleteRequest(`/host/cancel-subscription`, params),
  hostResumeSubscribtion : () => postRequest(`/host/resume-subscription`, {}),
  toggleNotification: () => postRequest("/auth/notification-toggle", {}),
};
